module.exports = __webpack_public_path__ + "media/components/src/assets/images/heading_with_sub/heading_with_sub_5-ef768d321b32c34c898dc954bf9699fc.png";